import React from "react";
import HomeIcon from "../../Assets/Icons/home.png";
import championshipIcon from "../../Assets/Icons/championship.png";
import settingsIcon from "../../Assets/Icons/setting.png";

const AdminBottomNavigation = ({ adminTab, setAdminTab }) => {
  return (
    <div className="admin-bottom-nav">
      <button
        className={adminTab === "dashboard" ? "active" : ""}
        onClick={() => setAdminTab("dashboard")}
      >
        <img src={HomeIcon} alt="Naslovna gumb" />
        <span>Admin</span>
      </button>
      <button
        className={adminTab === "bracket" ? "active" : ""}
        onClick={() => setAdminTab("bracket")}
      >
        <img src={championshipIcon} alt="Završnica" />
        <span>Uredi Završnicu</span>
      </button>
      <button
        className={adminTab === "settings" ? "active" : ""}
        onClick={() => setAdminTab("settings")}
      >
        <img src={settingsIcon} alt="postavke" />
        <span>Postavke</span>
      </button>
    </div>
  );
};

export default AdminBottomNavigation;
